module.exports = __webpack_public_path__ + "static/media/Butterfree_gaussian2.0712a55c.png";